export default "__VITE_ASSET__CnT0Dy1z__"